import type { Movie, MovieType } from "@/types/movie";

export const categories: { type: MovieType; label: string; desc: string; icon: string }[] = [
  {
    type: "电影",
    label: "电影",
    desc: "院线热映与经典佳作，剧情、动作、科幻、动画一网打尽",
    icon: "ri-film-line",
  },
  {
    type: "电视剧",
    label: "电视剧",
    desc: "年代大剧、都市情感、悬疑刑侦，追剧不停更",
    icon: "ri-tv-2-line",
  },
  {
    type: "综艺",
    label: "综艺",
    desc: "真人秀、音乐竞演、喜剧综艺，轻松解压好选择",
    icon: "ri-mic-line",
  },
];

export const movies: Movie[] = [
  {
    id: "gc001",
    title: "长津湖战役",
    type: "电影",
    year: 2021,
    region: "中国大陆",
    genres: ["战争", "剧情", "历史"],
    rating: 9.1,
    director: "陈国辉",
    actors: ["吴峻", "段奕宏", "朱亚文", "李晨"],
    synopsis: "抗美援朝长津湖战役中，志愿军将士在极寒天气下以血肉之躯坚守阵地，谱写一曲悲壮的英雄赞歌。",
    description:
      "1950年冬天，长津湖地区遭遇数十年不遇的极寒。志愿军某部七连奉命穿插至指定高地，切断敌军退路。面对装备精良、补给充足的对手，战士们在零下四十度的雪地里啃冻土豆、卧冰踏雪，用钢铁般的意志守住每一寸阵地。影片以群像叙事还原那场震撼人心的战役，既有恢弘的战争场面，也有战士之间质朴动人的情谊，展现了中国军人不畏强敌、保家卫国的英勇气概。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20Chinese%20war%20film%20poster%20art%2C%20soldiers%20silhouettes%20advancing%20through%20snowstorm%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grading%2C%20atmospheric%20layered%20composition%20with%20heavy%20negative%20space%2C%20high%20detail%20premium%20editorial%20poster%20design%2C%20no%20text&width=600&height=900&seq=cover-war-epic-01&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20landscape%20of%20snowy%20mountain%20battlefield%20at%20dusk%2C%20deep%20navy%20blue%20sky%20and%20warm%20amber%20light%20rays%2C%20distant%20figures%20marching%2C%20dramatic%20atmospheric%20fog%20and%20dust%2C%20moody%20film%20color%20grading%2C%20high%20detail%20premium%20editorial%20look%2C%20wide%20empty%20space%20on%20left%20side%2C%20no%20text&width=1600&height=900&seq=banner-war-epic-01&orientation=landscape",
    heat: 9820,
    updatedAt: "2025-09-28",
    tags: ["主旋律", "口碑爆款"],
  },
  {
    id: "gc002",
    title: "流浪地球",
    type: "电影",
    year: 2019,
    region: "中国大陆",
    genres: ["科幻", "冒险", "灾难"],
    rating: 9.2,
    director: "郭天骄",
    actors: ["屈楚萧", "李雪健", "吴峻", "赵今麦"],
    synopsis: "太阳即将毁灭，人类在地球表面建造巨大推进器，开启延续两千五百年的流浪之旅。",
    description:
      "近未来，太阳急速老化膨胀，地球即将被吞没。为了自救，人类倾尽全力建造上万座行星发动机，推动整个地球逃离太阳系，寻找新的家园。少年刘启与父亲、妹妹在地下城与地表之间辗转，卷入一场关乎全人类存亡的危机。影片以恢弘的想象力构建国产科幻世界观，既有冰冷的机械美学，也有父与子、人与家园之间温暖的情感内核，是国产科幻电影的里程碑之作。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20sci-fi%20Chinese%20film%20poster%20art%2C%20giant%20planet%20with%20glowing%20engines%20and%20blue%20thruster%20flames%2C%20deep%20navy%20sky%20with%20warm%20amber%20highlights%2C%20dramatic%20lighting%2C%20elegant%20negative%20space%2C%20high%20detail%20premium%20editorial%20poster%20design%2C%20abstract%20mechanical%20texture%2C%20no%20text&width=600&height=900&seq=cover-scifi-earth-02&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20landscape%20of%20planet%20Earth%20with%20thousands%20of%20glowing%20engines%2C%20deep%20navy%20blue%20space%20sky%20with%20warm%20amber%20light%20glow%2C%20atmospheric%20dust%20and%20nebula%2C%20moody%20film%20color%20grading%2C%20high%20detail%20premium%20editorial%20look%2C%20wide%20empty%20space%20on%20left%2C%20no%20text&width=1600&height=900&seq=banner-scifi-earth-02&orientation=landscape",
    heat: 9650,
    updatedAt: "2025-09-15",
    tags: ["科幻", "大制作"],
  },
  {
    id: "gc003",
    title: "我不是药神",
    type: "电影",
    year: 2018,
    region: "中国大陆",
    genres: ["剧情", "现实"],
    rating: 9.0,
    director: "文牧野",
    actors: ["徐峥", "王传君", "周一围", "谭卓"],
    synopsis: "一个卖印度神油的小老板，意外成为跨境代购救命药的“药神”，在情与法之间艰难抉择。",
    description:
      "保健品店老板程勇，生意惨淡、婚姻破裂，日子过得一团糟。一次偶然的机会，他接触到一批价格高昂的正版药与相对低廉的仿制药之间的巨大差价，由此走上代购之路。随着越来越多的病友找上门来，他逐渐从只想赚钱的商人，变成被寄予厚望的“药神”。影片用克制而温情的笔触，讲述普通人在困境中的挣扎与善意，直击现实议题，笑中带泪、余味悠长，被誉为国产现实主义题材的代表之作。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20realist%20drama%20film%20poster%20art%2C%20lone%20figure%20walking%20city%20street%20at%20night%2C%20deep%20navy%20blue%20shadows%20with%20warm%20amber%20streetlight%20glow%2C%20dramatic%20moody%20lighting%2C%20layered%20urban%20composition%2C%20elegant%20negative%20space%2C%20high%20detail%20premium%20editorial%20poster%20design%2C%20no%20text&width=600&height=900&seq=cover-drama-real-03&orientation=portrait",
    heat: 9210,
    updatedAt: "2025-08-30",
    tags: ["口碑", "现实主义"],
  },
  {
    id: "gc004",
    title: "满江红",
    type: "电影",
    year: 2023,
    region: "中国大陆",
    genres: ["悬疑", "喜剧", "古装"],
    rating: 8.3,
    director: "张艺谋",
    actors: ["沈腾", "易烊千玺", "张译", "雷佳音"],
    synopsis: "南宋绍兴年间，一桩发生在宰相府邸的命案，牵出一场步步惊心的权谋博弈。",
    description:
      "南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。小兵张大与亲兵营副统领孙均机缘巧合被裹挟进这场巨大的阴谋之中。随着调查深入，一个又一个深藏的算计被揭开，而所有人最终都指向同一个目标。影片以层层反转的叙事和局促密闭的空间营造紧张氛围，在悬疑与喜剧之间游走，展现中国传统忠义精神的当代回响。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20ancient%20Chinese%20historical%20suspense%20film%20poster%20art%2C%20traditional%20courtyard%20corridors%20with%20lanterns%2C%20deep%20navy%20blue%20night%20with%20warm%20amber%20lantern%20glow%2C%20dramatic%20moody%20lighting%2C%20layered%20architectural%20composition%2C%20elegant%20negative%20space%2C%20high%20detail%20premium%20editorial%20poster%20design%2C%20no%20text&width=600&height=900&seq=cover-suspense-han-04&orientation=portrait",
    heat: 8890,
    updatedAt: "2025-09-05",
    tags: ["反转", "古装"],
  },
  {
    id: "gc005",
    title: "消失的她",
    type: "电影",
    year: 2023,
    region: "中国大陆",
    genres: ["悬疑", "剧情"],
    rating: 8.1,
    director: "崔睿",
    actors: ["朱一龙", "倪妮", "文咏珊", "杜江"],
    synopsis: "妻子在异国旅行中神秘失踪，丈夫寻找无果，一场关于真相与谎言的博弈就此展开。",
    description:
      "何非与妻子李木子前往东南亚某海岛度假，妻子却在某天离奇失踪。当他四处寻找时，一个自称是他妻子的陌生女人突然出现，证件、指纹、照片全部吻合，唯独他不认识她。究竟是谁在说谎，真相被一层层迷雾包裹。影片以强烈的悬念钩子和频繁的反转推进剧情，探讨亲密关系中的信任与算计，海边潮湿迷离的氛围与节奏紧凑的叙事相得益彰，是当年话题度极高的悬疑佳作。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20suspense%20mystery%20film%20poster%20art%2C%20lone%20woman%20silhouette%20by%20tropical%20ocean%20cliff%2C%20deep%20navy%20blue%20sea%20and%20dusk%20sky%20with%20warm%20amber%20horizon%20glow%2C%20dramatic%20moody%20lighting%2C%20layered%20atmospheric%20composition%2C%20elegant%20negative%20space%2C%20high%20detail%20premium%20editorial%20poster%20design%2C%20no%20text&width=600&height=900&seq=cover-suspense-sea-05&orientation=portrait",
    heat: 8340,
    updatedAt: "2025-08-20",
    tags: ["反转", "话题"],
  },
  {
    id: "gc006",
    title: "你好，李焕英",
    type: "电影",
    year: 2021,
    region: "中国大陆",
    genres: ["喜剧", "剧情", "亲情"],
    rating: 8.8,
    director: "贾玲",
    actors: ["贾玲", "张小斐", "沈腾", "陈赫"],
    synopsis: "一场意外让女儿穿越回1981年，与年轻的母亲相遇，她想让妈妈这一生更幸福一点。",
    description:
      "母亲李焕英遭遇意外后，悲痛的女儿贾晓玲意外穿越回1981年，与正值青春的母亲相遇。她以“表妹”的身份陪伴在母亲身边，想方设法让妈妈开心、让妈妈过得更幸福，甚至想帮妈妈改写人生。可随着时间推移，她渐渐发现，妈妈的爱远比她想象的更深沉、更无私。影片用轻松喜剧的外壳包裹最真挚的亲情，笑点密集又泪点猝不及防，让无数观众在影院里笑着流泪，成为当年的现象级作品。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20warm%20Chinese%20family%20comedy%20film%20poster%20art%2C%20retro%201980s%20street%20scene%2C%20deep%20navy%20blue%20shadows%20with%20warm%20amber%20sunlight%20tone%2C%20nostalgic%20moody%20lighting%2C%20layered%20composition%2C%20elegant%20negative%20space%2C%20high%20detail%20premium%20editorial%20poster%20design%2C%20no%20text&width=600&height=900&seq=cover-comedy-family-06&orientation=portrait",
    heat: 8760,
    updatedAt: "2025-07-18",
    tags: ["亲情", "催泪"],
  },
  {
    id: "gc007",
    title: "封神第一部",
    type: "电影",
    year: 2023,
    region: "中国大陆",
    genres: ["奇幻", "动作", "古装"],
    rating: 8.4,
    director: "乌尔善",
    actors: ["费翔", "李雪健", "黄渤", "于适"],
    synopsis: "殷寿野心勃勃登临王位，姜子牙携封神榜下山，一场席卷三界的封神大战就此拉开。",
    description:
      "殷商末年，商王殷寿与狐妖妲己勾结，以残暴手段统治天下。年幼的姬发被送往朝歌成为质子，在忠义与父子之间挣扎。昆仑仙人姜子牙奉元始天尊之命，携封神榜下山，寻找天下共主，以救苍生。影片以宏大的神话世界观、精细的服化道和震撼的视效，重塑中国人自己的神话史诗，把“封神”这一国民IP拍出了恢弘气势与东方美学，被誉为国产奇幻工业化的新高度。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20mythological%20fantasy%20film%20poster%20art%2C%20ancient%20warrior%20with%20ornate%20armor%20and%20glowing%20magic%2C%20deep%20navy%20blue%20sky%20with%20warm%20amber%20divine%20light%2C%20dramatic%20moody%20lighting%2C%20layered%20epic%20composition%2C%20elegant%20negative%20space%2C%20high%20detail%20premium%20editorial%20poster%20design%2C%20no%20text&width=600&height=900&seq=cover-fantasy-gods-07&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20landscape%20of%20ancient%20Chinese%20mythical%20battlefield%2C%20giant%20divine%20statues%20and%20glowing%20energy%2C%20deep%20navy%20blue%20sky%20with%20warm%20amber%20god%20rays%2C%20atmospheric%20fog%20and%20dust%2C%20moody%20film%20color%20grading%2C%20high%20detail%20premium%20editorial%20look%2C%20wide%20empty%20space%20on%20left%2C%20no%20text&width=1600&height=900&seq=banner-fantasy-gods-07&orientation=landscape",
    heat: 8120,
    updatedAt: "2025-09-10",
    tags: ["神话", "大制作"],
  },
  {
    id: "gc008",
    title: "长安三万里",
    type: "电影",
    year: 2023,
    region: "中国大陆",
    genres: ["动画", "历史", "剧情"],
    rating: 8.9,
    director: "谢君伟",
    actors: ["杨天翔", "凌振赫", "宣晓鸣"],
    synopsis: "大唐盛世，高适回忆与李白相识相知的一生，四十八首唐诗串起一个璀璨的时代。",
    description:
      "安史之乱后，年迈的高适困守孤城，向监军回忆自己与李白的一生往事。从青年时的意气相投，到中年时各奔前程，两位诗人的人生轨迹映照出大唐由盛转衰的历史进程。影片以惊艳的水墨动画风格，将《静夜思》《将进酒》等传世名篇化作一幕幕视觉奇观，让观众在光影之间重回那个群星璀璨的诗意时代。近三个小时的片长里，历史、诗歌与人生彼此交织，是国产动画在题材与美学上的一次大胆突破。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20ink%20painting%20animation%20film%20poster%20art%2C%20poet%20gazing%20at%20moon%20over%20ancient%20city%2C%20deep%20navy%20blue%20sky%20with%20warm%20amber%20moonlight%2C%20dramatic%20atmospheric%20lighting%2C%20layered%20ethereal%20composition%2C%20elegant%20negative%20space%2C%20high%20detail%20premium%20editorial%20poster%20design%2C%20no%20text&width=600&height=900&seq=cover-animation-tang-08&orientation=portrait",
    heat: 8430,
    updatedAt: "2025-08-08",
    tags: ["国风", "动画"],
  },
  {
    id: "gc009",
    title: "狂飙",
    type: "电视剧",
    year: 2023,
    region: "中国大陆",
    genres: ["犯罪", "剧情", "悬疑"],
    rating: 9.1,
    director: "徐纪周",
    actors: ["张译", "张颂文", "李一桐", "张志坚"],
    synopsis: "一名基层刑警与黑恶势力长达二十年的正邪较量，一场关于坚守与沉沦的时代叙事。",
    description:
      "2000年，年轻的刑警安欣在一次调查中结识了鱼贩高启强，两人曾有过短暂的交集与善意。然而二十年间，高启强一步步从底层爬上黑恶势力的顶端，而安欣始终坚守初心，为扫黑除恶四处奔走。剧集以跨度二十年的双线叙事，刻画时代洪流下人物的选择与命运，正邪两方的塑造都立体丰满，节奏张弛有度，成为近年来国产刑侦剧的口碑标杆。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20crime%20drama%20poster%20art%2C%20rainy%20city%20street%20with%20police%20car%20lights%2C%20deep%20navy%20blue%20night%20with%20warm%20amber%20neon%20reflection%2C%20dramatic%20moody%20lighting%2C%20layered%20urban%20composition%2C%20elegant%20negative%20space%2C%20high%20detail%20premium%20editorial%20poster%20design%2C%20no%20text&width=600&height=900&seq=cover-crime-city-09&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20landscape%20of%20rainy%20night%20city%20skyline%20with%20neon%20reflections%2C%20deep%20navy%20blue%20tones%20with%20warm%20amber%20streetlights%2C%20atmospheric%20mist%20and%20bokeh%2C%20moody%20film%20color%20grading%2C%20high%20detail%20premium%20editorial%20look%2C%20wide%20empty%20space%20on%20left%2C%20no%20text&width=1600&height=900&seq=banner-crime-city-09&orientation=landscape",
    heat: 9960,
    updatedAt: "2025-09-30",
    episodeCount: 39,
    tags: ["刑侦", "高分"],
  },
  {
    id: "gc010",
    title: "人世间",
    type: "电视剧",
    year: 2022,
    region: "中国大陆",
    genres: ["剧情", "年代", "家庭"],
    rating: 8.9,
    director: "李路",
    actors: ["雷佳音", "辛柏青", "宋佳", "殷桃"],
    synopsis: "周家三兄妹五十年的人生沉浮，一部中国普通家庭的时代史诗。",
    description:
      "上世纪七十年代末，周家三个子女响应时代号召，各自走上不同的人生道路。大哥周秉义从政，二姐周蓉追求理想，小弟周秉昆留在城市照顾家人。五十年间，这个普通家庭经历了上山下乡、恢复高考、国企改革等时代变迁，也经历了聚散离合与爱恨情仇。剧集以细腻真实的笔触描摹平民百姓的悲欢，把大时代放进小家庭的烟火日常里，温暖而厚重，被观众称为“含着泪看完的年代剧”。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20family%20period%20drama%20poster%20art%2C%20retro%20old%20residential%20community%20street%2C%20deep%20navy%20blue%20shadows%20with%20warm%20amber%20afternoon%20light%2C%20nostalgic%20moody%20lighting%2C%20layered%20composition%2C%20elegant%20negative%20space%2C%20high%20detail%20premium%20editorial%20poster%20design%2C%20no%20text&width=600&height=900&seq=cover-family-era-10&orientation=portrait",
    heat: 9120,
    updatedAt: "2025-08-25",
    episodeCount: 58,
    tags: ["年代", "泪点"],
  },
  {
    id: "gc011",
    title: "三体",
    type: "电视剧",
    year: 2023,
    region: "中国大陆",
    genres: ["科幻", "悬疑", "剧情"],
    rating: 8.7,
    director: "杨磊",
    actors: ["张鲁一", "于和伟", "陈瑾", "王子文"],
    synopsis: "一场基础物理学的危机，引出一个跨越星系的文明博弈，人类的命运从此改变。",
    description:
      "纳米科学家汪淼卷入一连串科学家离奇死亡的谜案，与刑警史强联手调查，逐渐接触到神秘的“科学边界”组织。随着调查深入，一个关于地外文明“三体”的惊人真相浮出水面，人类文明正面临前所未有的挑战。剧集高度还原原著宏大的科幻设定，在缜密的悬疑推理中融入对人性与文明的思考，让国产科幻剧集在质感与思想深度上迈出重要一步。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20sci-fi%20Chinese%20series%20poster%20art%2C%20giant%20radio%20telescope%20under%20starry%20deep%20navy%20blue%20sky%20with%20warm%20amber%20signal%20glow%2C%20dramatic%20atmospheric%20lighting%2C%20layered%20cosmic%20composition%2C%20elegant%20negative%20space%2C%20high%20detail%20premium%20editorial%20poster%20design%2C%20no%20text&width=600&height=900&seq=cover-scifi-threebody-11&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20landscape%20of%20radio%20telescope%20array%20under%20vast%20starry%20deep%20navy%20blue%20night%20sky%20with%20warm%20amber%20glow%2C%20nebula%20and%20shooting%20stars%2C%20atmospheric%20moody%20film%20color%20grading%2C%20high%20detail%20premium%20editorial%20look%2C%20wide%20empty%20space%20on%20left%2C%20no%20text&width=1600&height=900&seq=banner-scifi-threebody-11&orientation=landscape",
    heat: 9540,
    updatedAt: "2025-09-20",
    episodeCount: 30,
    tags: ["科幻", "改编"],
  },
  {
    id: "gc012",
    title: "觉醒年代",
    type: "电视剧",
    year: 2021,
    region: "中国大陆",
    genres: ["历史", "剧情", "年代"],
    rating: 9.3,
    director: "张永新",
    actors: ["于和伟", "张桐", "马少骅", "侯京健"],
    synopsis: "从新文化运动到中国共产党成立，一群热血先辈在风雨如晦的年代里寻找救国之路。",
    description:
      "1915年，陈独秀创办《青年杂志》，新文化运动由此发端。李大钊、胡适、鲁迅、毛泽东等一代先驱，在思想激荡的年代里，为民族寻路、为民众启智。剧集以史诗般的笔触再现从新文化运动、五四运动到中国共产党成立的历史进程，把课本上的人物还原成有血有肉、有困惑也有热血的青年。台词隽永、画面考究，被称为“最生动的党史教科书”，也让无数年轻观众为之动容。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20history%20period%20drama%20poster%20art%2C%20vintage%20university%20courtyard%20with%20autumn%20leaves%2C%20deep%20navy%20blue%20shadows%20with%20warm%20amber%20sunlight%2C%20nostalgic%20moody%20lighting%2C%20layered%20architectural%20composition%2C%20elegant%20negative%20space%2C%20high%20detail%20premium%20editorial%20poster%20design%2C%20no%20text&width=600&height=900&seq=cover-history-awaken-12&orientation=portrait",
    heat: 9330,
    updatedAt: "2025-07-30",
    episodeCount: 43,
    tags: ["历史", "高分"],
  },
  {
    id: "gc013",
    title: "庆余年",
    type: "电视剧",
    year: 2019,
    region: "中国大陆",
    genres: ["古装", "权谋", "动作"],
    rating: 8.6,
    director: "孙皓",
    actors: ["张若昀", "李沁", "陈道明", "吴刚"],
    synopsis: "少年范闲带着现代记忆降生庆国，一路闯荡朝堂江湖，追寻身世与真相。",
    description:
      "身世神秘的少年范闲，自幼在澹州长大，带着现代人的记忆与见识。他来到京都，凭借聪慧与胆识在庙堂与江湖之间周旋，结识挚友、邂逅良缘，也一步步逼近自己身世的真相。剧集在热血爽感的成长线与错综复杂的权谋斗争之间游刃有余，人物鲜活、台词机敏，既有权谋剧的烧脑，也有少年意气的酣畅，是国产古装剧中的高分之作。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20ancient%20Chinese%20costume%20palace%20drama%20poster%20art%2C%20young%20scholar%20holding%20scroll%20before%20ornate%20palace%2C%20deep%20navy%20blue%20shadows%20with%20warm%20amber%20lantern%20glow%2C%20dramatic%20moody%20lighting%2C%20layered%20composition%2C%20elegant%20negative%20space%2C%20high%20detail%20premium%20editorial%20poster%20design%2C%20no%20text&width=600&height=900&seq=cover-costume-court-13&orientation=portrait",
    heat: 9010,
    updatedAt: "2025-08-12",
    episodeCount: 46,
    tags: ["权谋", "爽剧"],
  },
  {
    id: "gc014",
    title: "山海情",
    type: "电视剧",
    year: 2021,
    region: "中国大陆",
    genres: ["剧情", "现实", "年代"],
    rating: 9.2,
    director: "孔笙",
    actors: ["黄轩", "热依扎", "张嘉益", "闫妮"],
    synopsis: "西海固移民在戈壁滩上开荒建设新家园，用双手把干沙滩变成金沙滩。",
    description:
      "上世纪九十年代，宁夏西海固的移民们响应号召，从贫瘠的山区搬迁到戈壁滩上的玉泉营。面对漫天黄沙、缺水少电的困境，村支书马得福带着乡亲们种蘑菇、引黄河水、建扬水工程，一步步把荒滩变成宜居的家园。剧集以质朴真实的镜头语言和饱满的人物群像，讲述一段跨越二十余年的脱贫致富故事，笑点与泪点并存，被称为近年国产现实题材剧集的标杆。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20rural%20realist%20drama%20poster%20art%2C%20vast%20golden%20grassland%20with%20distant%20village%2C%20deep%20navy%20blue%20sky%20with%20warm%20amber%20sunset%20glow%2C%20dramatic%20atmospheric%20lighting%2C%20layered%20landscape%20composition%2C%20elegant%20negative%20space%2C%20high%20detail%20premium%20editorial%20poster%20design%2C%20no%20text&width=600&height=900&seq=cover-real-village-14&orientation=portrait",
    heat: 8890,
    updatedAt: "2025-07-22",
    episodeCount: 23,
    tags: ["现实", "感人"],
  },
  {
    id: "gc015",
    title: "奔跑吧",
    type: "综艺",
    year: 2024,
    region: "中国大陆",
    genres: ["真人秀", "竞技", "户外"],
    rating: 8.0,
    director: "浙江卫视",
    actors: ["李晨", "郑恺", "沙溢", "白鹿"],
    synopsis: "明星嘉宾组成跑男团，在城市与自然之间展开高能闯关游戏，欢乐与热血齐飞。",
    description:
      "作为国产户外竞技真人秀的代表，节目每季都邀请人气嘉宾组成跑男团，奔赴不同城市与场景，展开撕名牌、寻宝、团队对抗等一系列趣味任务。嘉宾之间默契十足、笑料不断，既有体力与智力的双重较量，也有温暖治愈的团队情谊。节目以轻松幽默的风格和积极向上的内核，成为许多人周末放松的固定选择。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20outdoor%20reality%20variety%20show%20poster%20art%2C%20energetic%20group%20of%20people%20running%20in%20city%20park%2C%20deep%20navy%20blue%20sky%20with%20warm%20amber%20sunshine%2C%20vibrant%20playful%20lighting%2C%20layered%20dynamic%20composition%2C%20elegant%20negative%20space%2C%20high%20detail%20premium%20editorial%20poster%20design%2C%20no%20text&width=600&height=900&seq=cover-variety-run-15&orientation=portrait",
    heat: 8210,
    updatedAt: "2025-09-25",
    episodeCount: 12,
    tags: ["户外", "欢乐"],
  },
  {
    id: "gc016",
    title: "极限挑战",
    type: "综艺",
    year: 2024,
    region: "中国大陆",
    genres: ["真人秀", "挑战", "剧情"],
    rating: 8.2,
    director: "东方卫视",
    actors: ["黄渤", "孙红雷", "黄磊", "王迅"],
    synopsis: "极限男人帮在城市街头完成烧脑任务，用智慧与默契演绎一出出“极限”好戏。",
    description:
      "节目以“这就是命”为信条，邀请极限男人帮在城市真实场景中完成一系列脑洞大开的任务。他们或是潜伏在人群中搜集线索，或是与素人嘉宾斗智斗勇，每一期都像一部跌宕起伏的迷你电影。嘉宾之间既竞争又合作，笑料与反转齐飞，同时也有对普通人生活的温情观察，是国产剧情式真人秀的经典代表。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20city%20challenge%20reality%20show%20poster%20art%2C%20group%20of%20people%20in%20urban%20night%20streets%2C%20deep%20navy%20blue%20night%20with%20warm%20amber%20neon%20glow%2C%20dramatic%20playful%20lighting%2C%20layered%20dynamic%20composition%2C%20elegant%20negative%20space%2C%20high%20detail%20premium%20editorial%20poster%20design%2C%20no%20text&width=600&height=900&seq=cover-variety-challenge-16&orientation=portrait",
    heat: 8350,
    updatedAt: "2025-09-12",
    episodeCount: 12,
    tags: ["烧脑", "团魂"],
  },
  {
    id: "gc017",
    title: "声生不息",
    type: "综艺",
    year: 2024,
    region: "中国大陆",
    genres: ["音乐", "竞演", "怀旧"],
    rating: 8.8,
    director: "湖南卫视",
    actors: ["林子祥", "叶倩文", "李健", "毛不易"],
    synopsis: "两岸三地歌手同台竞技，用歌声致敬经典，让岁月里的金曲重新焕发光彩。",
    description:
      "节目邀请内地与港台地区的老中青三代歌手同台，以音乐为纽带，重新演绎华语乐坛的经典金曲。舞台上既有殿堂级前辈的深情演唱，也有新生代歌手的创新改编，每期围绕不同主题展开竞演，用歌声讲述时代记忆与人生故事。节目制作精良、编排用心，让无数观众在熟悉的旋律里回到过去，成为近年口碑极佳的音乐综艺。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20music%20competition%20variety%20show%20poster%20art%2C%20singer%20on%20glowing%20concert%20stage%20with%20spotlight%2C%20deep%20navy%20blue%20darkness%20with%20warm%20amber%20stage%20glow%2C%20dramatic%20emotional%20lighting%2C%20layered%20composition%2C%20elegant%20negative%20space%2C%20high%20detail%20premium%20editorial%20poster%20design%2C%20no%20text&width=600&height=900&seq=cover-music-song-17&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20landscape%20of%20concert%20stage%20with%20warm%20amber%20spotlights%20and%20deep%20navy%20blue%20darkness%2C%20glowing%20microphone%20and%20atmospheric%20haze%2C%20moody%20emotional%20film%20color%20grading%2C%20high%20detail%20premium%20editorial%20look%2C%20wide%20empty%20space%20on%20left%2C%20no%20text&width=1600&height=900&seq=banner-music-song-17&orientation=landscape",
    heat: 8560,
    updatedAt: "2025-10-02",
    episodeCount: 13,
    tags: ["音乐", "怀旧"],
  },
  {
    id: "gc018",
    title: "王牌对王牌",
    type: "综艺",
    year: 2024,
    region: "中国大陆",
    genres: ["真人秀", "喜剧", "游戏"],
    rating: 8.1,
    director: "浙江卫视",
    actors: ["沈腾", "贾玲", "华晨宇", "关晓彤"],
    synopsis: "王牌家族每期邀请飞行嘉宾组队对抗，用游戏和才艺献上一场场欢乐盛宴。",
    description:
      "节目以“王牌家族”为核心班底，每期邀请不同领域的飞行嘉宾组成战队，通过抢答、才艺、游戏等环节展开对抗。嘉宾们临场反应与综艺感十足，配合默契笑料不断，同时也会在才艺展示环节带来惊喜表演。节目氛围轻松热闹、老少咸宜，是许多家庭围坐一起观看的解压首选。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20comedy%20game%20variety%20show%20poster%20art%2C%20colorful%20studio%20stage%20with%20playful%20props%2C%20deep%20navy%20blue%20backdrop%20with%20warm%20amber%20spotlights%2C%20vibrant%20fun%20lighting%2C%20layered%20dynamic%20composition%2C%20elegant%20negative%20space%2C%20high%20detail%20premium%20editorial%20poster%20design%2C%20no%20text&width=600&height=900&seq=cover-variety-ace-18&orientation=portrait",
    heat: 8290,
    updatedAt: "2025-09-18",
    episodeCount: 12,
    tags: ["喜剧", "合家欢"],
  },
];

export const regions: string[] = ["中国大陆", "中国香港", "中国台湾"];

export const allGenres: string[] = Array.from(
  new Set(movies.flatMap((m) => m.genres))
);